import {
  Button,
  Divider,
  Flex,
  Link,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { BLUEMONEDDBUTTONS, GRAY } from "../../../../constants/colors";
import {
  dateForList,
  dateForListWithHours,
} from "../../../../constants/dataFormat";
import {
  CNPJFormater,
  CPFFormater,
  ToLocaleFormat,
} from "../../../../defaultFunctions/formaters";
import InfoCardsDetalhamento from "../../boletos/defaultComponents/InfoCardsDetalhamento";

// "id": 0,
// "idTransacao": "string",
// "status": "string",
// "valor": 0,
// "valorOriginal": 0,
// "moeda": "string",
// "numeroTransacao": "string",
// "parcelas": 0,
// "idPagamento": "string",
// "idSeller": "string",
// "idCustomer": "string",
// "descricaoEC": "string",
// "clienteNome": "string",
// "bandeiraCartao": "string",
// "modoPagamento": "string",
// "idPOS": "string",
// "urlBoleto": "string",
// "urlPIX": "string",
// "qrCodePIX": "string",
// "dataExpiracao": "2023-03-17T20:06:27.226Z",
// "dataPagamento": "2023-03-17T20:06:27.226Z",
// "dataCriacao": "2023-03-17T20:06:27.226Z",
// "dataAtualizacao": "2023-03-17T20:06:27.226Z",
// "dataReversao": "2023-03-17T20:06:27.226Z",
// "dataEstorno": "2023-03-17T20:06:27.226Z",
// "taxaCliente": 0,
// "taxaPlano": 0,
// "valorLiquido": 0,
// "cartaoInicio": "string",
// "cartaoFim": "string",
// "reference_id": "string",
// "codigoAutorizacao": "string",
// "serialPOS": "string",
// "codigoAutorizacaoId": "string",
// "codigoNsu": "string",
// "bandeira": "string",
// "isCreditCard": true,
// "idCliente": 0,
// "nome": "string",
// "sobrenome": "string",
// "cnpj": "string",
// "isCnpj": true,
// "razaoSocial": "string",
// "nomeFantasia": "string",
// "nomeProjeto": "string",
// "idProjeto": 0,
// "idProduto": 0,
// "nomeModoPgto": "string",
// "statusTransacao": "string",
// "nomeProduto": "string",
// "idProvider": 0,
// "idBandeira": 0,
// "idStatus": 0,
// "idModoPagto": 0

export default function ModalDetailVendaBoleto({
  isOpen,
  setIsOpen,
  item,
}: any) {
  const finalRef = React.useRef(null);

  const onClose = () => {
    setIsOpen(false);
  };

  const [objetoPagamento, setObjetoPagamento] = useState<any>();
  // const [objetoSolicitante, setObjetoSolicitante] = useState<any>();
  const [objetoBeneficiario, setObjetoBeneficiario] = useState<any>();

  useEffect(() => {
    if (item && Object.keys(item).length !== 0) {
      const gerarObjetoPagamento = () => {
        return [
          {
            titulo: "Número da Transação: ",
            valor: item && item.numeroTransacao,
          },
          {
            titulo: "Modo de Pagamento: ",
            valor: item && item.nomeModoPgto,
          },
          {
            titulo: "Data de Criação: ",
            valor: item && moment(item.dataCriacao).format(dateForListWithHours),
          },
          {
            titulo: "Data do Vencimento: ",
            valor: item && moment(item.dataExpiracao).format(dateForList),
          },
          // {
          //   titulo: "Valor Nominal: ",
          //   valor: item && ToLocaleFormat(item.valorNominal),
          // },
          {
            titulo: "Valor Pagamento: ",
            valor: item && ToLocaleFormat(item.valorLiquido),
          },
        ];
      };

      // const gerarObjetoSolicitante = () => {
      //   return [
      //     {
      //       titulo: "Nome do Solicitante: ",
      //       valor:
      //         item && item?.cliente?.isCnpj === true
      //           ? `${item?.cliente?.razaoSocial}`
      //           : `${item.cliente.nome} ${item.cliente.sobrenome}`,
      //     },
      //     {
      //       titulo: "CPF/CNPJ do Solicitante: ",
      //       valor:
      //         item && item.cliente.isCnpj === true
      //           ? CNPJFormater(item.cliente.cnpj)
      //           : CPFFormater(item.cliente.cnpj),
      //     },
      //   ];
      // };

      const gerarObjetoBeneficiario = () => {
        return [
          // {
          //   titulo: "Nome do Beneficiário: ",
          //   valor: item.nomeBeneficiario,
          // },
          {
            titulo: "CPF/CNPJ do Beneficiário: ",
            valor:
              item && item.cnpj.length === 11
                ? CPFFormater(item.cnpj)
                : CNPJFormater(item.cnpj),
          },
        ];
      };
      // setObjetoSolicitante(gerarObjetoSolicitante());
      setObjetoBeneficiario(gerarObjetoBeneficiario());
      setObjetoPagamento(gerarObjetoPagamento());
    }

  }, [item]);

  function AbrirBoleto (url: any) {
    const a = document.createElement("a");
    a.href = url;
    a.target="_blank"
    a.click();
  }

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size={"4xl"}
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <ModalHeader>
            <Flex w={"100%"} justifyContent={"center"}>
              <Text fontWeight={"bold"}>
                Detalhamento da Solicitação de Pagamento
              </Text>
            </Flex>
          </ModalHeader>
          {item ? (
            <ModalBody
              display={"flex"}
              flexDir="column"
              justifyContent={"space-between"}
              alignItems="center"
            >
              <Flex
                w={"85%"}
                alignItems={"flex-start"}
                minHeight={"200px"}
                height={"fit-content"}
                border={"2px solid #c4c4c4"}
                flexDir={"column"}
                shadow={"md"}
                borderRadius={"6px"}
                px={4}
                py={4}
              >
                <InfoCardsDetalhamento
                  title={"Informações da Solicitação de Pagamento"}
                  array={objetoPagamento}
                />
                {/* <Divider variant="dashed"></Divider> */}
                {/* <InfoCardsDetalhamento
                  title={"Informações do Beneficiário"}
                  array={objetoBeneficiario}
                /> */}
              </Flex>
              <Button
                bgColor={BLUEMONEDDBUTTONS}
                color={"white"}
                my={2}
                onClick={() => AbrirBoleto(item.urlBoleto)}
              >
                Abrir Boleto
              </Button>
              <Flex
                w={"85%"}
                alignItems={"flex-start"}
                // minHeight={"250px"}
                // height={"40%"}
                border={"2px solid #c4c4c4"}
                flexDir={"column"}
                shadow={"md"}
                borderRadius={"6px"}
                px={1}
                py={1}
              >
                <iframe
                  src={item.urlBoleto}
                  width={"100%"}
                  height={"350px"}
                />
              </Flex>
              
            </ModalBody>
          ) : (
            <></>
          )} 
          <ModalFooter justifyContent={"space-evenly"}>
            <Button background={GRAY} color={"white"} mr={3} onClick={onClose}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
